import {Invoices} from '../services'

export const getInvoicesByUserId = async (userId) => {
    const snapshot = await Invoices.getUserInvoices(userId).get()
    return snapshot.docs.map(item => ({
        ...item.data(),
        id: item.id,
        notExpandable: true
    }))
}